document.addEventListener('DOMContentLoaded', function load() {

    if ( $(".pw_breadcrumb").length > 0 ) {
        $(".pw_breadcrumb").hide();
    }

    $("a .icon-cart").on("click", function(e){
        setTimeout(function(){ 
            replacePWimages();
        },1000);
    });

    if($(".pwGreetingCardsMain").length){

        // --- Build tokens from URL ---
        let pathParts = window.location.pathname.split('/').filter(Boolean); 

        // isolate parts after /a/
        let aIndex = pathParts.indexOf("a");
        let segments = aIndex >= 0 ? pathParts.slice(aIndex + 1) : pathParts;

        function formatToken(str) {
            return str
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }

        let breadcrumbHTML = "";
        let headerText = "";

        if (segments.length === 1) {
            let first = formatToken(segments[0]);
            headerText = first;
            breadcrumbHTML = `<span style="color:#0a1a5c; font-weight:bold;">${first}</span>`;
        } else if (segments.length === 2) {
            let first = formatToken(segments[0]);
            let second = formatToken(segments[1]);
            headerText = `${second} Cards`;
            breadcrumbHTML = `
                <a href="/a/${segments[0]}/" style="color:#0a1a5c; text-decoration:none;">${first}</a>
                / <span style="color:#0a1a5c; font-weight:bold;">${second}</span>
            `;
        } else if (segments.length >= 3) {
            let first = formatToken(segments[0]);
            let second = formatToken(segments[1]);
            let third = formatToken(segments[2]);
            headerText = `${second} Cards - ${third}`;
            breadcrumbHTML = `
                <a href="/a/${segments[0]}/" style="color:#0a1a5c; text-decoration:none;">${first}</a>
                / <a href="/a/${segments[0]}/${segments[1]}/" style="color:#0a1a5c; text-decoration:none;">${second}</a>
                / <span style="color:#0a1a5c; font-weight:bold;">${third}</span>
            `;
        }

        // Inject breadcrumb + header + description
        $("#main").before(`
            <section class="shopify-section shopify-section--collection-banner custom-banner-section">
                <div style="border-bottom: 1px solid rgb(217,217,217); padding: 10px 0 5px;" class="relative">
                    
                    <!-- Breadcrumb -->
                    <div class="custom-breadcrumb" style="font-size:13px; margin:0 0 20px 20px; text-align:left;">
                        ${breadcrumbHTML}
                    </div>

                    <!-- Header + description inside container -->
                    <div class="container container--sm text-center">
                        <div class="prose">
                            <h2 class="h3" style="margin:0 0 25px;">${headerText}</h2>
                            <p style="margin:0 auto 5px; font-size:15px; color:#333; max-width:75%;">
                                Personalised cards | 7,000+ designs | Add names, messages, or photos | A5 size (15 × 21 cm) | £3.99 each
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        `);

        // Apply negative margin to pull collection closer to divider
        $(".custom-banner-section").next().css("margin-top", "-35px");
    }

    // Add buttons dynamically under each tile
    $(".pw_category_block").each(function() {
        let title = $(this).find(".pw_category_block_title").text().trim();
        let link = $(this).find("a").attr("href");

        // Append a button only if it doesn't already exist
        if (!$(this).find(".pw_category_button").length) {
            $(this).append(`
                <a class="pw_category_button" href="${link}"> ${title}</a>
            `);
        }
    });

    function replacePWimages(){
        var textArray = $(".cart-drawer__items .line-item .line-item-info:contains('PersonalisationID')");
        textArray.each(function() {
            var cardID = this.innerText.match(/PersonalisationID:.*/);
            cardID = cardID[0].replace("PersonalisationID:", "").trim().match(/[^\s]+/)[0];
            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/11685/"+cardID+".jpg?r="+rand;
            $(this).parent().find("img").addClass("pwThumbImage");
            $(this).parent().find("img").attr("src",newSrc);
            $(this).parent().find("img").attr("srcset",newSrc);
        });
    }
}, false);
